import React, {Component} from "react";
import {connect} from "react-redux";
import {translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as modelHelper from "../../../../../helpers/modelHelper";
import * as stockActions from "../../../../../actions/stockActions";
import * as validationHelper from "../../../../../helpers/validationHelper";

import Button from "../../../../global/generic/Button";
import Modal from "../../../../global/generic/Modal";

class RemovePackageFromStockConfirmModal extends Component {
    constructor(props) {
        super(props);

        this.props.dispatchGetPackagesForColorantAction(this.props.params.colorant);

        this.state = {
            selectedPackage: 0,
            relevantPackages: this.getRelevantPackages()
        };
    }

    componentDidUpdate(prevProps) {
        if (!validationHelper.isEqual(prevProps.colorantPackages, this.props.colorantPackages)) {
            this.setState({
                relevantPackages: this.getRelevantPackages()
            });
        }
    }

    componentWillUnmount() {
        this.props.dispatchResetAllColorantPackagesAction();
    }

    handleCloseModalClick = () => {
        this.props.dispatchResetAllColorantPackagesAction();
        this.props.dispatchCloseRemovePackageFromStockConfirmModalAction();
    };

    handleConfirmClick = () => {
        if (this.state.relevantPackages.length === 0) {
            return;
        }

        this.props.dispatchRemoveColorantPackageFromStockAction(
            modelHelper.buildColorantPackageStock(
                this.state.relevantPackages[this.state.selectedPackage].key,
                this.state.relevantPackages[this.state.selectedPackage].item.package.name,
                this.state.relevantPackages[this.state.selectedPackage].item.colorant.name
            )
        );

        this.handleCloseModalClick();
    };

    handleSelectedPackageChange = (event) => {
        this.setState({
            selectedPackage: Number(event.target.value)
        });
    };

    getRelevantPackages = () => {
        return this.props.colorantPackages.filter((colorantPackage) => colorantPackage.currentValue > 0);
    };

    getHeader = () => {
        return modelHelper.buildModalSection(
            translate("stock.removePackageFromStock", {colorantName: this.props.params.colorant})
        );
    };

    getNoPackagesContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {translate("stock.noPackagesFoundInStockForColorant")}
                <br />
                {translate("stock.checkStockPackageInventory")}
            </React.Fragment>
        );
    };

    getOnePackageContent = () => {
        return modelHelper.buildModalSection(
            translate("stock.removePackageNameFromStock", {
                packageName: this.state.relevantPackages[0].item.package.displayName
            })
        );
    };

    getMultiplePackageContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {translate("stock.selectPackageToRemove", {
                    packageName: this.state.relevantPackages[0].item.package.displayName
                })}
                <select
                    value={this.state.selectedPackage}
                    className="primary-select font-size-3rem"
                    onChange={this.handleSelectedPackageChange}
                >
                    {this.state.relevantPackages.map((colorantPackage, index) => (
                        <option value={index} key={colorantPackage.key}>
                            {colorantPackage.item.package.displayName}
                        </option>
                    ))}
                </select>
            </React.Fragment>,
            "flex-column flex-gap-10px"
        );
    };

    getContent = () => {
        if (this.state.relevantPackages.length === 0) {
            return this.getNoPackagesContent();
        }

        if (this.state.relevantPackages.length === 1) {
            return this.getOnePackageContent();
        }

        return this.getMultiplePackageContent();
    };

    getNoPackagesFooter = () => {
        return null;
    };

    getFooter = () => {
        if (this.state.relevantPackages.length === 0) {
            return modelHelper.buildModalSection(
                <Button
                    className="flex-align-center min-width-150"
                    label={translate("general.ok")}
                    onClick={this.handleCloseModalClick}
                />
            );
        }

        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    className="flex-align-center min-width-150"
                    label={translate("general.yes")}
                    onClick={this.handleConfirmClick}
                />
                <Button
                    className="flex-align-center min-width-150"
                    label={translate("general.no")}
                    onClick={this.handleCloseModalClick}
                />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={this.getHeader()}
                content={this.getContent()}
                footer={this.getFooter()}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        colorantPackages: store.stock.colorantPackages
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseRemovePackageFromStockConfirmModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.REMOVE_PACKAGE_FROM_STOCK_CONFIRM_MODAL));
        },
        dispatchGetPackagesForColorantAction: (colorant) => {
            dispatch(stockActions.getColorantPackages(colorant));
        },
        dispatchResetAllColorantPackagesAction: () => {
            dispatch(stockActions.resetAllColorantPackages());
        },
        dispatchRemoveColorantPackageFromStockAction: (colorantPackageStock) => {
            dispatch(stockActions.removeColorantPackage(colorantPackageStock, false, true));
        }
    };
};

export default RemovePackageFromStockConfirmModal = connect(
    mapStoreToProps,
    mapDispatchToProps
)(RemovePackageFromStockConfirmModal);
